import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Modal } from 'antd';
import { UploadFileArea } from './upload-file-area.component';
import styled from '@xstyled/styled-components';
import { UploadOutlined } from '@ant-design/icons';
import { Heading3, PrimaryButton, SecondaryButton, TabComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-modal-content {\n    padding: 10px 16px;\n    border-radius: 16px;\n  }\n"])));
export var UploadImageModal = function UploadImageModal(props) {
  var isOpen = props.isOpen,
      file = props.file,
      onSaveImage = props.onSaveImage,
      isSavingFile = props.isSavingFile,
      isMultiple = props.isMultiple,
      onBeforeUploadImage = props.onBeforeUploadImage,
      label = props.label,
      _onDeleteFile = props.onDeleteFile,
      isUploading = props.isUploading,
      isSameImage = props.isSameImage,
      onCancel = props.onCancel;

  var beforeUpload = function beforeUpload(file) {
    onBeforeUploadImage(file);
  };

  var tabItems = [{
    key: 'upload',
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UploadOutlined, {}), label.upload]
    }),
    children: /*#__PURE__*/_jsx(UploadFileArea, {
      isUploading: isUploading,
      label: label.uploadFileAreaLabel,
      signedUrl: file === null || file === void 0 ? void 0 : file.url,
      onBeforeUpload: beforeUpload,
      isMultiple: isMultiple,
      onDeleteFile: function onDeleteFile() {
        return _onDeleteFile(file.id.toString());
      }
    })
  }];

  var renderFooter = function renderFooter() {
    var isFileNotExist = !file;

    if (isFileNotExist) {
      return null;
    }

    if (isSameImage) {
      return /*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancel,
        size: "middle",
        children: label.close
      });
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancel,
        disabled: isSavingFile,
        size: "middle",
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        disabled: isSavingFile,
        loading: isSavingFile,
        onClick: function onClick() {
          return onSaveImage(file);
        },
        children: label.save
      })]
    });
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    open: isOpen,
    centered: true,
    title: null,
    closable: true,
    onCancel: onCancel,
    footer: renderFooter(),
    children: [/*#__PURE__*/_jsx(Heading3, {
      children: label.attachImage
    }), /*#__PURE__*/_jsx(TabComponent, {
      items: tabItems
    })]
  });
};